import './TopMenu.css'
import React, { useState, useEffect, useRef } from 'react';
import { getAuth, signOut } from 'firebase/auth';
import img1 from '../../resources/ntai_logo.svg'
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../Components/AuthContext/AuthContext'
import InitialAvatar from '../InitialAvatar/InitialAvatar';

function TopMenu() {
    const auth = getAuth();

    const navigate = useNavigate(); // This hook is now properly imported

    const { userInfo } = useAuth();
    const profileRef = useRef(null);

    const [showProfile, setshowProfile] = useState(false);

    const handleNutritionistClick = () => {
        navigate('/ntai');
    };

    // Function to handle the click outside
    const handleClickOutside = (event) => {
        if ((profileRef.current && !profileRef.current.contains(event.target))) {
            setshowProfile(false);
        }
    };

    // Add event listener for clicks outside the div
    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    function logout() {
        if (window.confirm('Are you sure you want to logout?')) {
            signOut(auth)
            window.location.reload();

        }
    }

    const toggleDiv = (event) => {
        event.stopPropagation();
        setshowProfile(!showProfile)
    };
    return (
        <div className="basic-inputs-parent font_family_inter" ref={profileRef}>
            <div className="see-plans-parent">
                {
                    userInfo && !userInfo.active_subscription &&
                    <a href='/premium' className='text_decoration_none'>
                        <p className="see-plans gray_scale_2">See Plans</p>
                    </a>
                }
                <button className="top-menu-nutritionist-ai-btn" onClick={handleNutritionistClick}>
                    <div className="top-menu-nutritionist-ai-parent">
                        <p className="green_gradient_p font_weight_600">Nutritionist AI</p>
                        <img className="search-icon" alt="" src={img1} />

                    </div>
                </button>
                <div>
                    {
                        userInfo && userInfo.profile_picture ? (
                            <img
                                className="profile-img"
                                alt=""
                                src={userInfo.profile_picture}
                                onClick={() => setshowProfile(true)}
                                style={{ cursor: 'pointer' }}
                            />
                        ) : (
                            <span
                                onClick={toggleDiv}
                                style={{ cursor: 'pointer' }}
                            >
                                <InitialAvatar isSmall={true} />
                            </span>
                        )
                    }
                </div>
            </div>
            {
                showProfile && <div className='top_menu_profile_parent'>
                    <div className='font_family_inter font_size_14 gray_scale_1' onClick={() => { navigate('/profile-settings'); setshowProfile(false) }}>
                        Profile & Settings
                    </div>
                    <hr />
                    <div className='font_family_inter font_size_14 gray_scale_1' onClick={() => { navigate('/billing/overview'); setshowProfile(false) }}>
                        Billing
                    </div>
                    <hr />
                    <div className='font_family_inter font_size_14 gray_scale_1' onClick={() => { logout() }}>
                        Logout
                    </div>
                </div>
            }
        </div >

    );
}


export default TopMenu;